export default __webpack_public_path__ + "static/hade-vuyk-face-plastic-surgery-0df58142cc16edb282d7e87614381582.jpg";